import React from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'center',
    padding: theme.spacing(4),
  },
  icon: {
    fontSize: 48,
    marginBottom: theme.spacing(1),
    color: theme.palette.grey[400],
  },
}));

const EmptyState = ({ icon: Icon, title, description, children }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {Icon && <Icon className={classes.icon} />}
      {title && (
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
      )}
      {description && (
        <Typography variant="body2" color="textSecondary">
          {description}
        </Typography>
      )}
      {children}
    </div>
  );
};

EmptyState.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.node,
  description: PropTypes.node,
  children: PropTypes.node,
};

export default EmptyState;
